// function to handle resize events from dataTables -> cards & cards -> dataTables by defining obj and funcs to use based on screen sizes.
// Uses key assigned to .attr('data-resize_key')
// NOTE: Page-specific datatable functions (active_modules, overhead_management, etc.) are
// loaded via separate JS bundles only on pages that need them. The typeof guards below
// prevent errors when a function's bundle hasn't been loaded on the current page.
try{
    function get_resize_object(key){
        // object includes
            // base url for getting all of datatble type
            // func for building the data table
            // ajax_dt used to indicate if table will be using built in ajax processing

        switch (key) { // please add case alphabetically! - M.Yandow, Jun 11, 2024;
            case 'active_modules':
                if (typeof active_modules_dataTable === 'undefined') return false;
                return {
                    url: '/ajax/datatables/active_modules/',
                    func: active_modules_dataTable,
                    // card_view: false
                }
            case 'overhead_management':
                if (typeof overhead_management_dataTable === 'undefined') return false;
                return {
                    url: '/ajax/datatables/overhead_management/get_overhead_management_expenses/',
                    func: overhead_management_dataTable,
                    ajax_dt: true,
                    // card_view: true,
                    // cb_mobile: overhead_management_cards
                }
            case 'payment_history':
                if (typeof payment_history_dataTable === 'undefined') return false;
                return {
                    url: '/ajax/datatables/payment_history/',
                    func: payment_history_dataTable,
                    // card_view: true,
                    // cb_mobile: payment_history_cards
                }
            case 'recent_activity':
            case 'recent_activity_page':
            // Process is identical for page and modal so the functions have been combined to one process
                if (typeof create_recent_activity_table === 'undefined') return false;
                return {
                    url: '/ajax/datatables/recent_activity/',
                    func: create_recent_activity_table,
                }
            case 'payment_req_notes':
                if (typeof payment_req_notes === 'undefined') return false;
                return {
                    url: '/ajax/datatables/payment_req_notes/get_all_notes',
                    func: payment_req_notes,
                }
            case 'supply_locations':
                if (typeof supply_location_dataTable === 'undefined') return false;
                return {
                    url: '/ajax/datatables/supply_locations/get_supply_locations/',
                    func: supply_location_dataTable,
                    ajax_dt: true,
                    // card_view: false
                }

            default:
                return false;
          }
    }
}catch(e){
    console.log(e);
}
